import PropTypes from 'prop-types'
import WeeklyCalendarHeader from './WeeklyCalendarHeader'
import WeeklyCalendarGrid from './WeeklyCalendarGrid'
import WeeklyCalendarOverlays from './WeeklyCalendarOverlays'

const WeeklyCalendarCalendarView = ({
  currentWeek,
  navigateWeek,
  goToToday,
  startHour,
  endHour,
  savePreferences,
  resetPreferences,
  isDefault,
  weekDates,
  TIME_SLOTS,
  formatTimeSlot,
  isUserAvailable,
  getOpponentsAvailable,
  handleCellClick,
  allMatches,
  currentUserPlayerId,
  days,
  weekProposals,
  weekScheduledMatches,
  unplayedOpponents,
  divisionRoster,
  handleProposalClick,
  handleMatchClick,
}) => (
  <div className="calendar-view">
    <WeeklyCalendarHeader
      currentWeek={currentWeek}
      navigateWeek={navigateWeek}
      goToToday={goToToday}
      startHour={startHour}
      endHour={endHour}
      savePreferences={savePreferences}
      resetPreferences={resetPreferences}
      isDefault={isDefault}
    />

    <div className="calendar-container">
      <WeeklyCalendarGrid
        weekDates={weekDates}
        TIME_SLOTS={TIME_SLOTS}
        formatTimeSlot={formatTimeSlot}
        isUserAvailable={isUserAvailable}
        getOpponentsAvailable={getOpponentsAvailable}
        handleCellClick={handleCellClick}
        allMatches={allMatches}
        currentUserPlayerId={currentUserPlayerId}
        days={days}
      />

      <WeeklyCalendarOverlays
        weekProposals={weekProposals}
        weekScheduledMatches={weekScheduledMatches}
        weekDates={weekDates}
        TIME_SLOTS={TIME_SLOTS}
        unplayedOpponents={unplayedOpponents}
        allMatches={allMatches}
        currentUserPlayerId={currentUserPlayerId}
        divisionRoster={divisionRoster}
        handleProposalClick={handleProposalClick}
        handleMatchClick={handleMatchClick}
      />
    </div>
  </div>
)

WeeklyCalendarCalendarView.propTypes = {
  currentWeek: PropTypes.instanceOf(Date).isRequired,
  navigateWeek: PropTypes.func.isRequired,
  goToToday: PropTypes.func.isRequired,
  startHour: PropTypes.number.isRequired,
  endHour: PropTypes.number.isRequired,
  savePreferences: PropTypes.func.isRequired,
  resetPreferences: PropTypes.func.isRequired,
  isDefault: PropTypes.bool.isRequired,
  weekDates: PropTypes.arrayOf(PropTypes.instanceOf(Date)).isRequired,
  TIME_SLOTS: PropTypes.arrayOf(
    PropTypes.shape({
      hour: PropTypes.number.isRequired,
      minute: PropTypes.number.isRequired,
    }),
  ).isRequired,
  formatTimeSlot: PropTypes.func.isRequired,
  isUserAvailable: PropTypes.func.isRequired,
  getOpponentsAvailable: PropTypes.func.isRequired,
  handleCellClick: PropTypes.func.isRequired,
  allMatches: PropTypes.array.isRequired,
  currentUserPlayerId: PropTypes.number.isRequired,
  days: PropTypes.arrayOf(PropTypes.string).isRequired,
  weekProposals: PropTypes.array.isRequired,
  weekScheduledMatches: PropTypes.array.isRequired,
  unplayedOpponents: PropTypes.array.isRequired,
  divisionRoster: PropTypes.array.isRequired,
  handleProposalClick: PropTypes.func.isRequired,
  handleMatchClick: PropTypes.func.isRequired,
}

export default WeeklyCalendarCalendarView
